var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',{class:_vm.selected ? 'selected my-1' : '',attrs:{"link":"","dark":_vm.selected},on:{"click":_vm.select}},[_c('v-list-item-title',[_vm._v(_vm._s(_vm.simpleItem ? _vm.item : _vm.item[_vm.itemText]))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }